import { graphql } from "@/lib/gql/__generated__";

export const RESERVATION_DETAIL_FOR_MANAGEMENT_RESERVATION_ITEM_QUERY = graphql(/* GraphQL */ `
	query ReservationDetailForManagementReservationItem($hotelID: ID!, $reservationId: ID!) {
		reservationDetail(hotelID: $hotelID, reservationID: $reservationId) {
			id
			hotelID
			reservationID
			createdAt
			updatedAt
			statusRequest
			statusReservation
			statusRefund
			statusPayment
			statusNoShow
			statusReceiptIssued
			canRequestStatusChange
			canCancel
			willCancelPrice
			canUpdate
			canRefund
			canIssueReceipt
			canChargeCancelFee
			willCancelFeeChargePrice
			canHandleLocalPaymentCancelFee
			localCancelFeeTransferAccountName
			localCancelFeeTransferDate
			localCancelFeeTransferInfo {
				lackPrice
				rejectReason
				transferAccountName
				transferDate
			}
			guestName
			guestNameKana
			guestTel
			guestEmail
			guestPostalCode
			guestAddress
			isDayTrip
			adultNum
			kidsNum
			kidsNumDetail {
				age
				asCosleeping
			}
			roomNum
			isMailMagazineAccept
			memoByHost
			totalGuestCharge
			checkInDt
			checkOutDt
			refundedPriceByAdmin
			questionAndAnswerList {
				answer
				question
			}
			bookedGuestSurvey {
				answers {
					question
					answer
					answeredAt
				}
			}
			aliveItemsPerReservation {
				plan {
					name
					price
					hostInsertedPrice
					discountedPrice
				}
				options {
					name
					amount
					price
					hostInsertedPrice
					discountedPrice
				}
				additionalFees {
					name
					billingTypeTerm
					billingTypeTarget
					unitPrice
					totalPrice
					hostInsertedPrice
					totalDiscountedPrice
				}
				discount {
					name
					discountPrice
				}
				vouchers {
					name
					voucherPrice
				}
			}
			aliveItemsPerDate {
				date
				rooms {
					name
					roomNum {
						adultNum
						kidsNum {
							age
							asCosleeping
						}
						uniqueRoomID
					}
					price
					hostInsertedPrice
					discountedPrice
				}
				options {
					name
					amount
					price
					hostInsertedPrice
					discountedPrice
				}
			}
			deadItems {
				plan {
					name
					canceledPrice
				}
				rooms {
					name
					date
					roomNum {
						adultNum
						kidsNum {
							age
							asCosleeping
						}
						uniqueRoomID
					}
					canceledPrice
				}
				options {
					name
					dates
					amount
					canceledPrice
				}
				additionalFees {
					name
					billingTypeTerm
					billingTypeTarget
					canceledPrice
				}
			}
		}
		repeaterReservationList(hotelID: $hotelID, reservationID: $reservationId) {
			id
			hotelID
			hotelName
			reservationID
			guestName
			guestEmail
			checkInDt
			checkOutDt
			memoByHost
		}
	}
`);
